import React, {Component} from "react";

import {Link, withRouter} from "react-router-dom";

import "./SignUpPage.scss";

import LoadingIndicator from "../components/LoadingIndicator";
import ClientTransferCalculatorSignUp from "../components/transfercalculator/ClientTransferCalculatorSignUp";
import ClientCustomerTierTransferCalculator
    from "../components/transfercalculator/ClientCustomerTierTransferCalculator";


class CustomerTierCalculatorPage extends Component {
    state = {
        isLoading: false
    };
    onPaymentChanged = newPayment => {
        this.setState({
            payment: newPayment
        });
    };

    render() {
        if (this.state.isLoading) {
            return <LoadingIndicator/>;
        }
        return (
            <>
                <div className="sign-up-wrapper">

                    <div className="right-panel">
                        <div className="signup-page-body">
                            <div><ClientCustomerTierTransferCalculator transfer={this.state.payment}    customerTier = {this.props.match.params.customer_tier}
                                                                 onChange={this.onPaymentChanged}/></div>
                            <br/>
                        </div>
                        <div className="container-info">

                        </div>
                    </div>
                </div>

            </>
        );
    }
}

export default withRouter(CustomerTierCalculatorPage);
